import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '../../../core/services/auth.service';
import { ShellService } from '../../../core/services/shell.service';
import { DialogService } from '../../services/dialog.service';

/**
 * Contenido del menú de usuario (015 / 029 / 081). Dueño y sudo: Mi perfil · Centro de ayuda · Cerrar sesión.
 * Cerrar sesión confirma con el diálogo 076 antes de «Cerrando sesión…».
 * Cualquier opción cierra primero el menú (bottom sheet en celular) y el drawer del negocio, para que la
 * navegación o la confirmación se vean sobre una pantalla limpia.
 */
@Component({
  selector: 'app-user-menu',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="who">
      <span class="cr-avatar cr-avatar--44">{{ auth.initials() }}</span>
      <div class="txt"><p>{{ auth.fullName() }}</p><span>{{ auth.user()?.email }}</span></div>
    </div>
    <div class="cr-menu__sep"></div>
    <a class="cr-menu__item" ngbDropdownItem routerLink="/dashboard/profile" (click)="dismiss()"><cr-icon name="user" [size]="18" />Mi perfil</a>
    <a class="cr-menu__item" ngbDropdownItem routerLink="/dashboard/help" (click)="dismiss()"><cr-icon name="info" [size]="18" />Centro de ayuda</a>
    <div class="cr-menu__sep"></div>
    <button type="button" class="cr-menu__item" ngbDropdownItem (click)="logout()"><cr-icon name="logout" [size]="18" />Cerrar sesión</button>
  `,
  styles: [`
    .who{display:flex;align-items:center;gap:12px;padding:8px 10px 12px;min-width:0}
    .txt{min-width:0}
    .txt p{margin:0;font:600 15px/20px var(--cr-font-body)}
    .txt span{display:block;font:400 13px/18px var(--cr-font-body);color:var(--cr-text-secondary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
  `],
})
export class UserMenuComponent {
  readonly auth = inject(AuthService);
  private dialog = inject(DialogService);
  private router = inject(Router);
  private shell = inject(ShellService);
  private dropdown = inject(NgbDropdown, { optional: true });

  // region dismiss
  /** Cierra el menú de cuenta y el drawer del negocio (si estaba abierto) antes de navegar o abrir un diálogo. */
  dismiss(): void {
    this.dropdown?.close();
    this.shell.closeDrawer();
  }

  // region logout
  async logout(): Promise<void> {
    this.dismiss();
    const ok = await this.dialog.confirm({
      icon: 'logout',
      title: '¿Cerrar sesión?',
      body: 'Tendrás que volver a entrar con tu correo.',
      confirmLabel: 'Cerrar sesión',
      tone: 'primary',
    });
    if (ok) this.router.navigateByUrl('/logout');
  }
}
